<template>
    <v-container @mousemove="event => mousemove(event, this)" :class="$vuetify.breakpoint.mobile ? 'pa-0' : 'wrap'">
        <div ref="box">
            <ts-nft :premint_id="premint_id" :example="nft"></ts-nft>
        </div>

        <!--<div ref="box" class="_3d">
            <v-card height="100%" width="100%" color="black" class="front d-flex align-center justify-center" position="front">
                <ts-nft premint_id="bJ1L2wrG8DrUbAexygknNi" :example="nft"></ts-nft>
            </v-card>
            <v-card height="100%" color="black" class="left d-flex align-center justify-center" position="left">
                <v-img contain :src="nft.photos[0].url"></v-img>
            </v-card>
            <v-card height="100%" width="100%" color="black" class="back d-flex align-center justify-center" position="back">
                <v-img contain :src="nft.photos[1].url"></v-img>
            </v-card>
            <v-card height="100%" color="black" class="right d-flex align-center justify-center" position="right">
                <v-img contain :src="nft.photos[2].url"></v-img>
            </v-card>
        </div>-->
    </v-container>
</template>
<style scoped>
@keyframes spin {
    0% {
        transform: rotateX(0deg) rotateY(0deg);
    }
    100% {
        transform: rotateX(0deg) rotateY(360deg);
    }
}
.wrap-mobile {
    transform: scale(0.2) translate(-200%, -200%);
}
._3d {
    transform-style: preserve-3d;
    height: 1280px;
    width: 100%;
    transform: scale(0.9);
}
.wrap {
    perspective: 3840px;
    perspective-origin: 50% 640px;
    width: 1620px;
}
.front {
    position: absolute;
    transform: translateZ(640px);
    backface-visibility: hidden !important;
}
.left {
    position: absolute;
    transform: rotateY(270deg) translateX(-640px);
    transform-origin: center left;
    backface-visibility: hidden !important;
}
.back {
    position: absolute;
    transform: translateZ(-640px) rotateY(180deg);
    backface-visibility: hidden !important;
}
.right {
    position: absolute;
    transform: rotateY(-270deg) translateX(640px);
    transform-origin: top right;
    backface-visibility: hidden !important;
}
.animate {
    animation: spin 5s infinite ease-in-out;
}
</style>
<script>
import {} from "@mdi/js";
import nft from '../assets/nft.js';
import TsNft from "./TsNft.vue";

if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    nft.assets = nft.assets.map(asset => {
        asset.url = asset.url.replace('.webp', '.jpeg')
        return asset
    })
}

export default {
    name: "TsNftExample",
    components: {
        TsNft,
    },
    props: {},
    methods: {
        transforms(x, y, el) {
            const constraint = 30;
            let box = el.getBoundingClientRect();
            let calcX = (y - box.y - (box.height / 2)) / constraint;
            let calcY = (x - box.x - (box.width / 2)) / constraint;
            return `rotateY(${calcY}deg) rotateX(${calcX}deg)`
        },
        transformElement(el, xyEl) {
            el.style.transform  = this.transforms.apply(null, xyEl);
        },
        mousemove(e, self) {
            let xy = [e.clientX,e.clientY];
            const ex1Layer = this.$refs['box'];
            let position  = xy.concat([ex1Layer]);

            window.requestAnimationFrame(function(){
                self.transformElement(ex1Layer, position);
            });
        }
    },
    data: function () {
        return {
            nft,
        };
    },
    computed: {
        premint_id() {
            return nft.premint_id;
        }
    },
    mounted() {
        this.$on("load", function () {
            setTimeout(() => {}, 1000);
        });
    },
    watch: {
        isLoading() {
            const self = this;
            if (!self.isLoading)
                self.$nextTick(() => {
                    setTimeout(function () {}, 1000);
                });
        },
    },
};
</script>
